// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"styles-module--breadcrumbs--cLx3J","breadcrumbs__separator":"styles-module--breadcrumbs__separator--1t9h2"};